<div #sidenav>
  <jsg-sticky-toolbar class="toolbar sticky">
    <div
      left-bar
      fxLayout="row"
      fxLayoutAlign="start center"
      *ngIf="actionNumber"
    >
      <div fxLayout="row">
        <mat-spinner
          *ngIf="!actionNumber"
          color="primary"
          diameter="20"
        ></mat-spinner>
        <h3 *ngIf="actionNumber">Court Case: {{ actionNumber }}</h3>
        <span
          class="view-link"
          *ngIf="showViewLink"
          (click)="view.emit(actionNumber)"
          >View</span
        >
      </div>
    </div>
    <div
      middle-bar
      fxLayout="row"
      fxLayoutAlign="start center"
      *ngIf="styleOfCause"
    >
      <div fxLayout="row">
        <div *ngIf="styleOfCause" fxLayout="row" fxLayoutGap="10px">
          <span class="action-bar-label">Style of cause: </span>
          <span class="action-bar-text"> {{ styleOfCause }}</span>
        </div>
      </div>
    </div>
    <div
      right-bar
      fxLayout="row"
      fxLayoutAlign="start center"
      *ngIf="civilMatterType"
    >
      <div fxLayout="row">
        <div *ngIf="civilMatterType" fxLayout="row" fxLayoutGap="10px">
          <span class="action-bar-label">Civil matter type: </span>
          <span class="action-bar-text"> {{ civilMatterType }}</span>
        </div>
      </div>
    </div>
    <div
      end-bar
      fxLayout="row"
      fxLayoutAlign="start center"
      *ngIf="actionButtonText && actionNumber"
    >
      <div fxLayout="row">
        <button mat-stroked-button color="primary" (click)="action.emit()">
          {{ actionButtonText }}
        </button>
      </div>
    </div>

    <div
      end-bar
      fxLayout="row"
      fxLayoutAlign="start center"
      *ngIf="showJoinAction"
    >
      <div fxLayout="row">
        <button mat-stroked-button color="primary" (click)="joinActionClick()">
          Join Action
        </button>
      </div>
    </div>
  </jsg-sticky-toolbar>
</div>
